import React, { useState } from 'react';
import moment from 'moment';
import { useNavigate } from "react-router-dom";
import { Button } from '@prosolve/common-components-ui'
import { getClientSubdomain, getIsProsolveSubdomain, getIsEventDelivered } from '../../utils';
import useIsMobileView from "../../hooks/useIsMobileView";
import useDataTrainers from '../../dataHooks/useDataTrainers';
import { FaRegCalendar, FaArrowRight, FaRegEnvelope, FaCheckCircle, FaSync } from 'react-icons/fa';
import ImagePlaceholder from '../../images/image-placeholder.jpg';
import EventTrainerInvitationResponseModal from './EventTrainerInvitationResponseModal';
import EventMyCompButton from './EventMyCompButton';

export default ({
  eventData = {},
  onReloadData
}) => {
  const {
    id = '',
    name = '',
    accountName = '',
    startDate = '',
    endDate = '',
    image = '',
    trainerId = '',
    trainerNames = '',
    trainerRequestStatus = '',
    trainerTotalCompensation,
    projectStatus
  } = eventData;

  const isMobileView = useIsMobileView();

  const navigate = useNavigate();

  const clientSubdomain = getClientSubdomain()
  
  const isProsolveSubdomain = getIsProsolveSubdomain()
  const isStarSubdomain = (clientSubdomain === 'star')

  const isEventDelivered = getIsEventDelivered(eventData, isStarSubdomain)

  const { calculateNames } = useDataTrainers();

  const trainerNamesLength = trainerNames?.split(',').length - 1
  const trainerNamesDisplay = trainerNames?.replace(/,\s*$/, "")

  const onClick = () => {
    navigate(`event?id=${id}`);
  }

  const formatDates = () => {

    const start = moment(startDate).format('MMM DD');
    const end = moment(endDate).format('MMM DD');
    const year = moment(endDate).format('YYYY');

    return `${start} - ${end}, ${year}`;
  }
  
  const onSyncTrainerNamesClick = async () => {
    await calculateNames(eventData)
    onReloadData()
  }

  const hasTrainerRequestResponseButtons = ['Waiting to Send', 'Requested'].indexOf(trainerRequestStatus) > -1;

  const [respondToInvitationOpen, setRespondToInvitationOpen] = useState(false)

  return (
    <div 
      style={{
        display: 'flex',
        flexDirection: isMobileView ? 'column' : 'row',
        border: "1px solid #C2C9D1",
        borderRadius: "5px",
        height: isMobileView ? 'auto' : '200px'
      }}
    >
      {
        respondToInvitationOpen &&
        <EventTrainerInvitationResponseModal
          eventData={eventData}
          onClose={() => setRespondToInvitationOpen(false)}
          onSuccess={() => {
            onReloadData()
            setRespondToInvitationOpen(false)
          }}
        />
      }
      <div style={{
        flex: 4,
        display: 'flex',
      }}>
        <img style={{ width: '100%', borderTopLeftRadius: '5px', borderBottomLeftRadius: '5px', objectFit: 'cover' }} src={image || ImagePlaceholder} alt='eventImage' />
      </div>
      <div style={{
        flex: 6,
        display: 'flex',
        flexDirection: 'column',
        padding: '20px'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          paddingTop: isMobileView ? '10px' : '0px'
        }}>
          <div style={{
            flex: 1,
            fontWeight: 'bold',
            fontSize: '16px',
            color: '#565656',
            display: 'flex',
            alignItems: 'center'
          }}>
            <FaRegCalendar style={{ marginRight: '5px' }} />
            {formatDates()}
          </div>
          {['Tentative','Canceled'].includes(projectStatus) &&
            <div style={{
              padding: '0 10px',
              outline: 'solid 1px #F58025',
              borderRadius: '15px',
              color: 'hsl(26, 91%, 55%)'
            }}>
              {projectStatus}
            </div>
          }
          {isEventDelivered &&
            <div style={{
              padding: '1px 10px',
              outline: 'solid 1px #565656',
              borderRadius: '15px',
              color: '#565656',
              background: '#ededed'
            }}>
              {'Closed'}
            </div>
          }
        </div>
        <div style={{
          fontSize: '28px',
          fontWeight: 'bold',
          marginTop: '5px'
        }}>
          {name}
        </div>
        <div style={{
          marginTop: '5px',
          fontSize: '15px',
          fontStyle: 'italic',
          color: '#404040'
        }}>
          {accountName}
        </div>
        {isProsolveSubdomain && trainerId && trainerTotalCompensation > 0 &&
          <div style={{
            display: 'flex',
            marginTop: '5px',
          }}>
            <EventMyCompButton eventData={eventData} />
          </div>
        }
        {isStarSubdomain &&
          <div style={{
            marginTop: '5px',
            fontSize: '15px',
            fontStyle: 'italic',
            color: '#404040'
          }}>
            {trainerNames?.length > 0 
              ? `Trainer${trainerNamesLength === 1 ? '' : 's'}: ${trainerNamesDisplay}` 
              : <Button 
                  style={{ 
                    display: 'inline-flex', 
                    border: 'none',
                    position: 'relative',
                    left: '-10px'
                  }} 
                  onClick={onSyncTrainerNamesClick}
                >
                  <FaSync style={{ marginRight: '5px', color: '#0280c6', fontSize: '18px' }}  />
                  <span>{'Sync Trainer Names'}</span>
                </Button>
            }
          </div>
        }
        <div style={{ flex: 1 }}>&nbsp;</div>
        <div style={{ display: 'flex'}}>
          <Button 
            style={{ 
              display: 'inline-flex', 
              border: 'none',
              position: 'relative',
              left: '-10px'
            }} 
            onClick={onClick}
          >
            <span style={{ fontWeight: 'bold', fontSize: '15px' }}>{'View Event'}</span>
            <FaArrowRight style={{ marginLeft: '10px', color: '#0280c6', fontSize: '18px' }}  />
          </Button>
          <div style={{ flex: 1 }}>&nbsp;</div>
          { hasTrainerRequestResponseButtons ?
            <Button 
              style={{ 
                display: 'inline-flex', 
              }} 
              onClick={() => setRespondToInvitationOpen(true)}
            >
              <FaRegEnvelope style={{ marginRight: '10px', color: '#0280c6', fontSize: '18px' }}  />
              <span style={{ fontWeight: 'bold', fontSize: '15px' }}>{'Respond to trainer invitation'}</span>
            </Button>
            :
            <Button 
              $disabled={true}
              style={{ 
                display: 'inline-flex',
                background: '#ffffff',
                border: 'none'
              }} 
              onClick={() => {}}
            >
              <FaCheckCircle style={{ marginRight: '5px', color: '#0280c6', fontSize: '18px' }}  />
              <span style={{ fontWeight: 'bold', fontSize: '15px' }}>{'Accepted'}</span>
            </Button>
          }
        </div>
      </div>
    </div>
  )
}